import { useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import AppContext from "../../context";

import { ReactComponent as PlusIcon } from '../../images/plus-black.svg';
import { ReactComponent as BookingsIcon } from '../../images/bookings-black.svg';
import { ReactComponent as PersonIcon } from '../../images/person-black.svg';
import { ReactComponent as WalletIcon } from '../../images/wallet-black.svg';

import styles from '../../styles/Tabs.module.scss';

function Tabs() {
	const context = useContext(AppContext);
	const location = useLocation();

	const isClinicOrSalon = context.domain.businessType === 'clinic' || context.domain.businessType === 'salon' || context.domain.businessType === 'restaurant';
	const isHybrid = context.domain.businessType === 'hybrid' || context.domain.businessType === 'hybrid-new';

	if (isClinicOrSalon) {
		return (
			<div className={styles.tabs}>
				<NavLink to="/dashboard/services" activeClassName={"active"}>
					<PlusIcon />
					<p>Services</p>
				</NavLink>

				<NavLink to="/dashboard/my-service-bookings" activeClassName={"active"}>
					<BookingsIcon />
					<p>Appointments</p>
				</NavLink>

				{context.domain.walletEnabled ? (
					<NavLink to="/dashboard/wallet" activeClassName={"active"}>
						{location.pathname.includes("/dashboard/wallet") ?
							<img src={require('../../images/wallet-blue.svg').default} alt={""} />
							:
							<img src={require('../../images/wallet-black.svg').default} alt={""} />
						}
						<p>Wallet</p>
					</NavLink>
				) : null}

				<NavLink to="/dashboard/settings" activeClassName={"active"}>
					<PersonIcon />
					<p>Settings</p>
				</NavLink>
			</div>
		);
	}

	return (
		<div className={styles.tabs}>
			<NavLink to="/dashboard/book" activeClassName={"active"}>
				<PlusIcon />
				<p>Book</p>
			</NavLink>

			<NavLink to="/dashboard/bookings" activeClassName={"active"}>
				<BookingsIcon />
				<p>Bookings</p>
			</NavLink>

			{isHybrid ? (
				<NavLink to="/classes" activeClassName={"active"}>
					<PlusIcon />
					<p>Classes</p>
				</NavLink>
			) : null}

			<NavLink to="/dashboard/tokens" activeClassName={"active"}>
				<WalletIcon />
				<p>Tokens</p>
			</NavLink>

			<NavLink to="/dashboard/settings" activeClassName={"active"}>
				<PersonIcon />
				<p>Settings</p>
			</NavLink>
		</div>
	);
}

export default Tabs;
